module.exports = "<p>\n  scora-common-module works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/application/core-module/scora-common-module/scora-common-module.component.html
// module id = 1015
// module chunks = 6